"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14 12.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m8.8 5.1-.9 1.2a.5.5 0 0 1-.4.2h-2A2.5 2.5 0 0 0 3 9v7.5A2.5 2.5 0 0 0 5.5 19h13a2.5 2.5 0 0 0 2.5-2.5V9a2.5 2.5 0 0 0-2.5-2.5h-2a.5.5 0 0 1-.4-.2l-.9-1.2a1.5 1.5 0 0 0-1.2-.6h-4a1.5 1.5 0 0 0-1.2.6m6.2 7.4a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })]
}), 'CameraFilled');
//# sourceMappingURL=index.js.map